import React from "react";
import { Box, Typography, Button } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import bgImg from "../../assets/landing/AboutUs/About-Us.jpg";
import badgeImg from "../../assets/landing/AboutUs/30-badge.png";
import slideImg from "../../assets/landing/bg-slide-1.jpg";

const AboutUsSection = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "auto", // or whatever height you need
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)),
                 url(${slideImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Box
        width={{ xl: "70%", lg: "90%", md: "85%", sm: "90%", xs: "95%" }}
        sx={{
          py: 8,
          maxWidth: 1200,
          margin: "auto",
          borderBottom: "1px solid #31B44B",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            mb: 6,
          }}
        >
          <Box
            sx={{ flex: 1, borderBottom: "1px solid", borderColor: "#31B44B" }}
          />
          <Typography
            variant="h2"
            component="h1"
            className="welcome-title-text"
            sx={{
              fontSize: { xs: "2rem", sm: "2.5rem" },
              mx: 2,
              whiteSpace: "nowrap",
              color: "#232323",
            }}
          >
            About Us
          </Typography>
          <Box
            sx={{ flex: 1, borderBottom: "1px solid", borderColor: "#31B44B" }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column-reverse", md: "row" },
            gap: 6,
            alignItems: "center",
          }}
        >
          {/* Text Content */}
          <Box
            sx={{ flex: 1, textAlign: { xs: "center", md: "left" } }}
            className="dmsans-texts"
          >
            <Typography
              variant="h5"
              component="p"
              className="felipa-texts"
              sx={{
                fontStyle: "italic",
                mb: 3,
                color: "black",
              }}
            >
              Elit pellentesque habitant morbi tristique senectus et. Faucibus
              turpis in eu mi bibendum.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                mb: 3,
                lineHeight: 1.8,
                color: "#555",
              }}
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                mb: 4,
                lineHeight: 1.8,
                color: "#555",
              }}
            >
              Duis aute irure dolor in reprehenderit in voluptate velit esse
              cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
              cupidatat non proident, sunt in culpa qui officia deserunt mollit
              anim id est laborum.
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "flex-start" },
              }}
            >
              <Button
                variant="contained"
                className="dmsans-texts"
                sx={{
                  px: 4,
                  py: 1.5,
                  backgroundColor: "#31B44B",
                  color: "white",
                  borderRadius: 0,
                  "&:hover": {
                    backgroundColor: "#232323",
                  },
                  letterSpacing: 2
                }}
              >
                READ MORE
                <PlayArrowIcon />
              </Button>
            </Box>
          </Box>

          {/* Image with Badge */}
          <Box sx={{ flex: 1, position: "relative", width: "100%" }}>
            <Box
              component="img"
              src={bgImg}
              alt="About Us"
              sx={{
                width: "100%",
                height: "400px",
                borderRadius: 5,
                boxShadow: 3,
              }}
            />
            <Box
              component="img"
              src={badgeImg}
              alt="30 Years Badge"
              sx={{
                position: "absolute",
                bottom: 10,
                right: 10,
                width: { xs: "140px", sm: "200px", md: "220px" },
                height: "auto",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutUsSection;
